import React, { useEffect, useCallback } from "react";
import {
  Box,
  Button,
  Grid,
  InputLabel,
  TextField,
} from "@mui/material";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useStyle } from "../../../HR/Pages/Attendance/attendance-styles";
import Modal from "../../../../Components/Modal/Modal";
import AutoCompleteSearch from "../../../../Components/AutoCompleteSearch/AutoCompleteSearch";
import { getAllEmployees } from "../../../../Redux/Actions/HR";
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const IssueRecallAssetModal = React.memo(({ // Using React.memo for performance optimization
  open,
  onClose,
  assetId,
  isRecall,
  employeesList,
  employeeId,
  onSubmit,
  setEmployeeId,
  setNotes,
}) => {
  const classes = useStyle();
  const dispatch = useDispatch();


    useEffect(() => {
    dispatch(getAllEmployees());
  }, [dispatch]);

     const handleNotesChange = useCallback((e) => {
        if (typeof setNotes === "function") setNotes(e.target.value);
    }, [setNotes]);

    const handleFormSubmit = useCallback((e) => {
      e.preventDefault();
      if (typeof onSubmit === "function") onSubmit();
    }, [onSubmit]);


  return (
    <Modal
      open={open}
      setOpen={onClose}
      title={isRecall ? "Recall Asset" : "Issue Asset"}
      size="600"
    >
      
  <Form onSubmit={handleFormSubmit}> 
          <Box>
            <Grid container columnSpacing={7}>
              {!isRecall ? (
                <Grid item md={12}> 
                  <Box sx={{ my: 2 }}>
                    <InputLabel className={classes.department_label}>
                      Assign To
                    </InputLabel>
                    <AutoCompleteSearch
                      data={employeesList}
                      departmentData={employeeId}
                      setDepartmentData={setEmployeeId}
                      title={"Search Employee..."}
                    />
                  </Box>
                </Grid>
              ) : null}

              <Grid item md={12}> 
                <Box sx={{ my: 2 }}>
                  <InputLabel className={classes.department_label}>
                    Notes
                  </InputLabel>
                  <TextField
                    placeholder="Enter Notes"
                    fullWidth
                    rows={3}
                    multiline
                    className={classes.inputContainer}
                    name="notes"
                    onChange={handleNotesChange}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <Box sx={{ display: "flex", gap: "10px" }}>
              <Button
                variant="contained"
                type="button"
                className={classes.cancelBtn}
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                type="submit"
                className={classes.createLeaveBtn}
              >
                {isRecall ? "Recall" : "Issue"}
              </Button>
            </Box>
          </Box>
        </Form>
      
    </Modal>
  );
});

IssueRecallAssetModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  assetId: PropTypes.string,
  employeesList: PropTypes.array,
  onSubmit: PropTypes.func.isRequired,
  isRecall: PropTypes.bool.isRequired,
  setEmployeeId: PropTypes.func,
  setNotes: PropTypes.func,
};

export default IssueRecallAssetModal;
